import React, { useContext } from 'react'
import { hasAccessToAdmin } from '../../../utils/user/permissions'
import { UserContext } from '../../wrappers/UserContext'
import UserDropdown from '../user/UserDropdown'
import AdminLink from './AdminLink'

const LandingPageNav = () => {
    const { roles } = useContext(UserContext)
    return (
        <div className="navbar landingNav">
            <div className="navbar-end">
                {hasAccessToAdmin(roles) ? (
                    <div className="navbar-item">
                        <AdminLink />
                    </div>
                ) : null}
                <UserDropdown roles={roles} />
            </div>
        </div>
    )
}

export default LandingPageNav
